import React, { useEffect, useState } from "react";
import { useSimulationStore } from "../../store/simulationStore";

function toUtcInputValue(date: Date): string {
  return date.toISOString().slice(0, 16);
}

export function DateTimeControl() {
  const currentDateUtc = useSimulationStore((s) => s.currentDateUtc);
  const setDate = useSimulationStore((s) => s.setDate);
  const resetToNow = useSimulationStore((s) => s.resetToNow);
  const [inputValue, setInputValue] = useState(toUtcInputValue(currentDateUtc));

  useEffect(() => {
    setInputValue(toUtcInputValue(currentDateUtc));
  }, [currentDateUtc]);

  return (
    <div className="tls-astro-control-block">
      <label htmlFor="tls-astro-datetime">Data e hora (UTC)</label>
      <input
        id="tls-astro-datetime"
        type="datetime-local"
        value={inputValue}
        onChange={(e) => {
          setInputValue(e.target.value);
          const next = new Date(`${e.target.value}:00.000Z`);
          if (!Number.isNaN(next.getTime())) setDate(next);
        }}
      />
      <button type="button" onClick={resetToNow}>
        Agora
      </button>
    </div>
  );
}
